<template>
  <div class="left-nav" :class="getWidth">
    <div class="nav-top">
      <template v-if="isCollapse">
        <img :src="miniLogoUrl" alt="" />
      </template>
      <template v-else>
        <img :src="logoUrl" alt="" class="qianse_logo" />
        <img :src="ssLogoUrl" alt="" class="shense_logo" style="display: none;" />
      </template>
    </div>
    <el-menu
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      text-color="#fff"
      :default-active="navselected"
      mode="horizontal"
      :collapse="isCollapse"
      :collapse-transition="false"
    >
      <el-menu-item key="home" index="home" style="height: 0">
        <div>
          <i class=""></i>
          <span slot="title"></span>
        </div>
      </el-menu-item>
      <template v-for="(item, index) of list">
        <template v-if="item.children">
          <el-submenu
            :label="Language(item.name)"
            :value="item.id"
            :key="index"
            :index="item.id"
            :title="Language(item.name)"
          >
            <template slot="title">
              <i :class="getIcon(item.picCode)" class="iconfont"></i>
              <span slot="title">{{ Language(item.name) }}<b class="menu_num" v-if="item.qty && (item.qty > 0)">{{item.qty>99?'99+':item.qty}}</b></span>
            </template>
            <menu-tree :menuData="item.children" :menuGroupName="item.name" @menuClick="navListClick"></menu-tree>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item
            @click="navListClick(item)"
            :label="Language(item.name)"
            :value="item.id"
            :key="index"
            :index="item.name"
            :title="Language(item.name)"
          >
            <template>
              <i :class="getIcon(item.menuGroupPicCode)" class="iconfont"></i>
              <span slot="title">{{ Language(item.name) }}<b class="menu_num" v-if="item.qty && (item.qty > 0)">{{item.qty>99?'99+':item.qty}}</b></span>
            </template>
          </el-menu-item>
        </template>
      </template>
    </el-menu>

    <div class="nav-bottom">
      <div
        href="javascript:;"
        @click="asideToggle"
        :title="navToggleMsg"
        class="nav-bottom-r"
        :class="{ nav_bottom_l_hide: isCollapse }"
        ><i class="font-14 iconfont" :class="navToggleImg"></i></div>
    </div>
  </div>
</template>
<script>
import "./css/LeftNav.css";
import { mapMutations, mapGetters } from "vuex";
import { getLoginInfo } from "../../http/MenuManagement.js";
import { getValidList } from "../../http/RedbookManagement.js";

import MenuTree from './menuTree'

export default {
  name: "LeftNav",
  components: {
    MenuTree
  },
  data() {
    return {
      isCollapse: false,
      navselected: "999",
      isActive: true,
      error: null,
      vdnId: "",
      agentId: "",
      fowardPath: "",
      list: [],
      DATAOBJ: {},
      userObj: {},
      logoUrl: '',
      ssLogoUrl: '',
      miniLogoUrl: '',
    };
  },
  watch: {
    getNavType: function (newd, old) {
      this.navselected = newd;
    },
    "$store.state.navTabs.menuList":{
      deep: true,
      handler(val, oldVal) {
        this.list = JSON.parse(JSON.stringify(val))
      },
    }
  },
  computed: {
    ...mapGetters(["menus", "barEffect"]),
    navToggleImg() {
      //展开折叠更换图片
      return this.isCollapse? 'iconzhankaicaidan' : 'iconshousuocaidan';
    },
    navToggleMsg() {
      //展开折叠更换文字
      return this.isCollapse ? "展开" : "折叠";
    },
    getWidth() {
      return {
        "nav-hide": this.isCollapse,
      };
    },
    getNavType() {
      return this.$store.state.navTabs.activeTabName;
    },
  },
  created() {
    this.userObj = JSON.parse(LocalStorage.getItem("obj"));

    let path = '';
    //-----个性配置----------
    if(window.projectConfig && window.projectConfig.logoPathName){
      path = '_' + window.projectConfig.logoPathName;
    }
    this.logoUrl = 'static/images'+ path +'/logo.png'
    this.ssLogoUrl = 'static/images'+ path +'/logo-ss.png'
    this.miniLogoUrl = 'static/images'+ path +'/logo-mini.png'

  },
  mounted() {
    this.loadMenuList();
  },
  methods: {
    ...mapMutations("navTabs", ["addTab"]),
    getIcon(item) {
      //设置菜单组图标
      return item == "" || item == null ? "icon-caidanzumorentupian" : item;
    },
    navListClick(item) {
      this.addTab(item);
      this.$store.commit("navTabs/setmsgTabNum", 1);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    asideToggle() {
      this.isCollapse = !this.isCollapse;
      if (this.isCollapse) {
        let oldClass = document.getElementsByTagName("body")[0].className;
        document.getElementsByTagName("body")[0].className =
          "aside-min " + oldClass;
      } else {
        let oldClass = document.getElementsByTagName("body")[0].className;
        oldClass = oldClass.replace("aside-min ", "");
        oldClass = oldClass.replace("aside-min", "");
        document.getElementsByTagName("body")[0].className = oldClass;
      }
    },
    setNavlistLocalstorage(name, obj) {
      LocalStorage.setItem(name, JSON.stringify(obj));
    },
    //获取菜单并获取权限
    loadMenuList() {
      let param = {
        vdnId: this.userObj.vdnId,
      };
      getLoginInfo(param).then((res) => {
        if (res && res.data) {
          let list = res.data.menuList;
          list.map((o) => {
            o.id = String(o.id);
          });
          this.list = list;
          this.$store.state.navTabs.menuList = list;
          //调用红名单接口获取数据
          // this.getVaildListFn();

          SessionStorage.setItem("powerList", JSON.stringify(res.data.powerList)); //权限列表
          this.powerListSet() //权限设置到变量里

          this.$store.state.navTabs.picPath = res.data.picPath?res.data.picPath:'static/images/004.png';
        }
      });
    },
    //红名单数据
    getVaildListFn() {
      let data = {
        vdnId: this.userObj.vdnId
      }
      getValidList(data).then((res) => {
        if(res && res.retCode == 1){
          //获取到的红名单数据放在临时缓存里
          if(res.data.length){
            SessionStorage.setItem('redBookList', JSON.stringify(res.data));
          }
        }
      });
    },
  }
};
</script>
<style scoped>
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  display: none !important;
}
.left-nav .el-menu.el-menu--horizontal {
  height: calc(100% - 90px);
  overflow: auto;
}
.nav-bottom-r{
  color: #fff;
}
.shense .qianse_logo{
  display: none;
}
.shense .shense_logo{
  display: inline-block!important;
}
</style>



// WEBPACK FOOTER //
// LeftNav.vue?67955a74